// The web's own label for "the server answered 409", thrown by hooks and matched by screens. Named so it
// can't be read as a server ErrorCode: the 409 body may carry any code, or none.
export const CLIENT_CONFLICT_MARKER = 'ClientConflict';
